import(/* webpackMode: "eager", webpackExports: ["BiteSharedReport"] */ "/home/runner/work/ticker-bullstory/ticker-bullstory/frontend/src/components/bite/bite-shared-report.tsx");
